// extracted by mini-css-extract-plugin
module.exports = {"main":"AvailabilityResult_main__2vUgz","filters":"AvailabilityResult_filters__IXvgJ","hotels":"AvailabilityResult_hotels__22Tf9","hotel":"AvailabilityResult_hotel__334o0"};